import React from 'react';
import { Form, Button, DatePicker, Select } from 'antd';
import { observer } from 'mobx-react';
import echarts from 'echarts';
import './index.styl';
import { getDeviceUser, getDeviceSn, getCurveDate } from '../request/dao';

const clzpre = 'ssfe-distance';
const FormItem = Form.Item;
const { Option } = Select;

const DEFAULT_OPTION = {
    title: {
        text: '激光测距',
        left: 'center',
        align: 'right',
        textStyle: {
            color: '#fff',
        },
    },
    grid: {
        bottom: 80,
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            animation: false,
            label: {
                backgroundColor: '#505765',
            },
        },
    },
    legend: {
        data: ['气压(KPA)'],
        right: 10,
    },
    dataZoom: [
        // {
        //     show: true,
        //     realtime: true,
        //     start: 0,
        //     end: 100,
        // },
        // {
        //      type: 'inside',
        //      realtime: true,
        //      start: 0,
        //      end: 100
        //  }
        {
            id: 'dataZoomX',
            type: 'slider',
            xAxisIndex: [0],
            start: 0,
            end: 100,
        },
        {
            id: 'dataZoomY',
            type: 'slider',
            yAxisIndex: [0],
            start: 0,
            end: 100,
        },
    ],
    xAxis: [
        {
            type: 'time',
            axisLabel: {
                color: '#fff',
            },
            axisLine: {
                lineStyle: {
                    color: '#fff',
                },
            },
        },
    ],
    yAxis: [
        {
            type: 'value',
            axisLabel: {
                color: '#fff',
            },
            axisLine: {
                lineStyle: {
                    color: '#fff',
                },
            },
        },
    ],
    series: [
        {
            name: '距离',
            type: 'line',
            data: [],
        },
    ],
};

class TopOperation extends React.Component {
    constructor(props) {
        super(props);
        getDeviceSn();
        getDeviceUser();
    }

    confirmSubmitForm = () => {
        this.props.form.validateFields((err, value) => {
            if (!err) {
                const { deviceUser, deviceSn, startTime, endTime } = value;
                const param = {
                    deviceUser,
                    deviceSn,
                    beginInMillis: startTime
                        ? parseInt(startTime.valueOf() / 1000)
                        : undefined,
                    endInMillis: endTime
                        ? parseInt(endTime.valueOf() / 1000)
                        : undefined,
                };
                getCurveDate(param).then(() => {
                    this.props.onQuerySuccess();
                });
            }
        });
    };

    render() {
        const { form, userList, sensorList } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Form layout={'inline'} hideRequiredMark>
                <FormItem label={'使用方'}>
                    {getFieldDecorator('deviceUser')(
                        <Select style={{ width: 160 }} placeholder={'请选择'}>
                            {(userList || []).map((item) => (
                                <Option key={item}>{item}</Option>
                            ))}
                        </Select>
                    )}
                </FormItem>
                <FormItem label={'传感器编号'}>
                    {getFieldDecorator('deviceSn')(
                        <Select style={{ width: 160 }} placeholder={'请选择'}>
                            {(sensorList || []).map((item) => (
                                <Option key={item}>{item}</Option>
                            ))}
                        </Select>
                    )}
                </FormItem>
                <FormItem label={'开始时间'}>
                    {getFieldDecorator('startTime')(<DatePicker showTime />)}
                </FormItem>
                <FormItem label={'结束时间'}>
                    {getFieldDecorator('endTime')(<DatePicker showTime />)}
                </FormItem>
                <Button onClick={this.confirmSubmitForm}>查询</Button>
            </Form>
        );
    }
}

const TopOperationForm = Form.create()(TopOperation);

@observer
class DistanceCom extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        setTimeout(() => {
            this.chart = echarts.init(this.chartRef);
        }, 200);
    }

    redraw = () => {
        this.chart.setOption(DEFAULT_OPTION);
        const { curveData: { data = [] } = {} } = this.props.SensorStore;
        const lineData = data.map((item) => [item.timestamp, item.value]);
        this.chart.setOption({
            series: [
                {
                    data: lineData,
                },
            ],
        });
    };

    render() {
        const {
            deviceSn: sensorList,
            deviceUser: userList,
            curveData,
        } = this.props.SensorStore;
        console.log(userList);
        return (
            <div className={`${clzpre}`}>
                <div className={'top-operation'}>
                    <TopOperationForm
                        sensorList={sensorList}
                        userList={userList}
                        onQuerySuccess={this.redraw}
                    />
                </div>
                <div
                    className={'chart'}
                    ref={(e) => {
                        this.chartRef = e;
                    }}></div>
            </div>
        );
    }
}

export default DistanceCom;
